export default __webpack_public_path__ + "static/media/content-illustrations-gift-blue.a20e5eba.svg";